import { useMutation } from 'react-query';
import request from '../../../../../helpers/request';

const changePermit = async ({ id, value }) => {
  return await request.put(
    `/Access/transport/${id}`,
    value,
    'При изменении пропуска произошла ошибка',
    'Error'
  );
};

const useChangePermit = (onSuccess) =>
  useMutation(changePermit, {
    onSuccess: (data) => {
      if (data === 'Error') return;

      if (typeof onSuccess === 'function') onSuccess();
    },
  });

export default useChangePermit;
